import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

const intlPrefix = 'sizesModal';

export const defined = defineMessages({
  breitlingStrapSize: {
    id: `plp.strapSize.heading`,
    defaultMessage: 'Breitling strap size',
  },
  howToMeasure: {
    id: `plp.strapSize.howToMeasure`,
    defaultMessage: 'How to measure your wrist?',
  },
  needARuler: {
    id: `plp.strapSize.needARuler`,
    defaultMessage: 'Need a ruler for measurements?',
  },
  printTheRuler: {
    id: 'plp.strapSize.printTheRuler',
    defaultMessage: 'Print the ruler',
  },
  strapSize: {
    id: `plp.strapSize.form.strapSize`,
    defaultMessage: 'strap size',
  },
  wristSize: {
    id: `plp.strapSize.form.wristSize`,
    defaultMessage: 'wrist size',
  },
  small: {
    id: `plp.strapSize.form.small`,
    defaultMessage: 'small',
  },
  smallSize: {
    id: `plp.strapSize.form.smallSize`,
    defaultMessage: '135mm to 160mm',
  },
  smallSizeInch: {
    id: `plp.strapSize.form.smallSizeInch`,
    defaultMessage: '5.3 to 6.3 inch',
  },
  standard: {
    id: `plp.strapSize.form.standard`,
    defaultMessage: 'standard',
  },
  standardSize: {
    id: `plp.strapSize.form.standardSize`,
    defaultMessage: '160mm to 190mm',
  },
  standardSizeInch: {
    id: `plp.strapSize.form.standardSizeInch`,
    defaultMessage: '6.3 to 7.5 inch',
  },
  large: {
    id: `plp.strapSize.form.large`,
    defaultMessage: 'large',
  },
  largeSize: {
    id: `plp.strapSize.form.largeSize`,
    defaultMessage: '190mm to 215mm',
  },
  largeSizeInch: {
    id: `plp.strapSize.form.largeSizeInch`,
    defaultMessage: '7.5 to 8.5 inch',
  },
});

export const MeasuringTool = (
  <FormattedMessage
    defaultMessage='measuring tool'
    id='plp.strapSize.measuringTool'
  />
);
export const TopDescription = (downloadedSizePdfHref: string) => (
  <FormattedMessage
    defaultMessage='To find the best fit of a strap or bracelet, please use our wrist {measuringTool}. Most of our straps come in Short, Standard and Long lengths, with ranges varying slightly based on case size and thickness of the compatible watch.'
    id='plp.strapSize.topDescription'
    values={{
      measuringTool: (
        <LinkWithLocale href={downloadedSizePdfHref} target='_blank'>
          {MeasuringTool}
        </LinkWithLocale>
      ),
    }}
  />
);

export const MiddleDescription = (
  <FormattedMessage
    defaultMessage='We offer complimentary sizing of metal bracelets when a watch is purchased online or through our contact center. For rubber straps, we recommend a visit to one of our boutiques or authorized dealers to properly size the band.'
    id='plp.strapSize.middleDescription'
  />
);

export const PrintTheRuler = (
  <FormattedMessage
    defaultMessage='Print the ruler'
    id={`${intlPrefix}.printTheRuler`}
  />
);

export const BottomDescription = (
  <FormattedMessage
    defaultMessage='Please be aware of the instruction in the paper for the correct measurement and of the possibility of possible small discrepancy in measures.'
    id='plp.strapSize.bottomDescription'
  />
);
